import vacant from '@/assets/images/driver-status/map/taxi.png'
import logout from '@/assets/images/driver-status/map/logout.png'
import suspension from '@/assets/images/driver-status/ban.png'
import rest from '@/assets/images/driver-status/map/rest.png'
import dispatched from '@/assets/images/driver-status/map/hailing.png'
import shift from '@/assets/images/driver-status/map/shift.png'
import disappearance from '@/assets/images/driver-status/map/interrupt.png'
import hired from '@/assets/images/driver-status/map/take_passenger.png'

// 叫車紀錄
export const driverStatus = {
  0: {
    name: '休息中',
    img: rest,
  },
  1: {
    name: '空車',
    img: vacant,
  },
  2: {
    name: '派遣中',
    img: dispatched,
  },
  3: {
    name: '載客中',
    img: hired,
  },
  4: {
    name: '排班車',
    img: shift,
  },
  5: {
    name: '登出',
    img: logout,
  },
  6: {
    name: '失聯',
    img: disappearance,
  },
  7: {
    name: '停權車',
    img: suspension,
  },
}

export const driverRes = {
  1: '搶單成功',
  2: '拒絕',
  3: '閒置',
  4: '搶單失敗',
}

// 叫車紀錄總查詢
export const driverReceived = {
  billInfo: {
    reservationType: 0,
    orderId: '',
    reservationTime: '',
    onLocation: '',
    offLocation: '',
    passengerOnLacatioNote: '',
    passengerNote: '',
    result: '',
    call_method: '',
    passengerCancel: '',
    driverCancel: '',
    passengerPhone: '',
    passengerName: '',
  },
  managerInfo: {
    name: '',
  },
  serviceInfo: {
    name: '',
  },
  passengerInfo: {
    phone: '',
    name: '',
  },
  driverInfo: {
    teamName: '',
    phone: '',
    callNumber: '',
  },
}

// 司機發訊息總表，發訊息modal中的司機狀態
export const driverStatusList = [
  {
    status: null,
    name: '不選擇',
  },
  /* {
    status: 0,
    name: '離線',
  }, */
  {
    status: 1,
    name: '空車',
  },
  {
    status: 2,
    name: '派遣中',
  },
  {
    status: 3,
    name: '載客中',
  },
]



// WEBPACK FOOTER //
// ./src/constants/driver.js